import { AccountsThemeHelper } from '@accounts/domain';
import { getAvailableLanguages } from '@accredible-frontend-v2/services/language';
import { accredibleCustomThemesMetadata } from '@accredible-frontend-v2/utils/themes';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'acs-panel',
  templateUrl: './panel.component.html',
  styleUrls: [`./panel.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelComponent {
  @Input()
  showBackToSignIn = false;

  readonly themeName = AccountsThemeHelper.getTheme();
  readonly languages = getAvailableLanguages(
    accredibleCustomThemesMetadata[this.themeName].languages,
  );
  readonly bannerImagePath = '/assets/images/banner_image.jpg';
  readonly bannerBackgroundGradient = 'linear-gradient(to bottom left, #3a3a86, #272652)';
}
